const loadTheme = () => {
  try {
    const theme = require(`globalconfig/theme/${window.$environment.SERVICE_PROVIDER}/${window.$environment.CURRENT_LAYOUT}`)
      .default;

    const GlobalTheme = require(`globalconfig/theme/${window.$environment.SERVICE_PROVIDER}/${window.$environment.CURRENT_LAYOUT}/GlobalTheme`)
      .default;
    return { theme, GlobalTheme };
  } catch (error) {
    const theme = require(`globalconfig/theme/${window.$environment.SERVICE_PROVIDER}`)
      .default;

    const GlobalTheme = require(`globalconfig/theme/${window.$environment.SERVICE_PROVIDER}/GlobalTheme`)
      .default;
    return { theme, GlobalTheme };
  }
};
export default loadTheme();
